'use client';

import { createClient } from '@/lib/supabase/client';

interface AmbassadorApplicationData {
  fullName: string;
  email: string;
  phone: string;
  location: string;
  skills: string[];
  backgroundInfo: string;
  experience: string;
  motivation: string;
  availability: string;
  institutionalInterests: string[];
}

function isSchemaError(error: any): boolean {
  if (!error) return false;
  
  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') {
      return true;
    }
    if (errorClass === '23') {
      return false;
    }
  }
  
  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
      /syntax error/i,
      /invalid.*syntax/i,
      /type.*does not exist/i,
      /undefined.*column/i,
      /undefined.*table/i,
    ];
    return schemaErrorPatterns.some(pattern => pattern.test(error.message));
  }
  
  return false;
}

export const ambassadorService = {
  async submitApplication(data: AmbassadorApplicationData) {
    const supabase = createClient();

    try {
      const { data: result, error } = await supabase
        .from('ambassador_applications')
        .insert({
          full_name: data.fullName,
          email: data.email,
          phone: data.phone,
          location: data.location,
          skills: data.skills,
          background_info: data.backgroundInfo,
          experience: data.experience,
          motivation: data.motivation,
          availability: data.availability,
          institutional_interests: data.institutionalInterests,
        })
        .select()
        .single();

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Data error:', error.message);
          return null;
        }
      }

      return result;
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};